import { setIn as ImmutabilitySetIn } from 'timm'

/** * Immutability helper for nested objects */
export function setIn(object, path, value) {
  return ImmutabilitySetIn(object, path.split('.'), value)
}
